import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../views/Login";
import Register from "../views/Register";
import Index from "../views/Index";
import store from "../store";
import BoardDetails from "../components/BoardDetails";
import AuthForm from "../views/common/AuthForm";
import DetailAuthForm from "../views/company/DetailAuthForm";
// import DataQualityEvaluation from "../views/company/QualityEvaluation/DataQualityEvaluation";

import { initMenu } from "@/utils/menu";
import DataRegistration from "../views/company/DataRegistration";

Vue.use(VueRouter);

const routes = [


    {
        //注册页面组件
        path: '/register',
        name: 'Register',
        component: Register
    },
    {
        //登录页面组件
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        //管理员登录页面组件
        path: '/admin/login',
        name: 'AdminLogin',
        component: () => import('../views/AdminLogin.vue')
    },


    {
        path: '/',
        component: () => import('@/views/website/WebsiteHome.vue'),
        children: [
            {
                path: '',  // 空路径，匹配根路径
                name: 'CompanyHome',
                component: () => import('../views/website/HomeContent.vue')
            },
            {
                path: 'websiteHome',
                name: 'WebsiteHome',
                component: () => import('../views/website/HomeContent.vue')
            },
            {
                path: 'registration',
                name: 'WebsiteRegistration',
                component: () => import('@/views/website/WebsiteRegistration.vue')
            },
            {
                path: 'compliance',
                name: 'WebsiteCompliance',
                component: () => import('@/views/website/WebsiteCompliance.vue')
            },
            {
                path: 'quality',
                name: 'WebsiteQuality',
                component: () => import('@/views/website/WebsiteQuality.vue')
            },
            {
                path: 'valuation',
                name: 'WebsiteValuation',
                component: () => import('@/views/website/WebsiteValuation.vue')
            },
            {
                path: 'finance',
                name: 'WebsiteFinance',
                component: () => import('@/views/website/WebsiteFinance.vue')
            },
            {
                path: 'about',
                name: 'WebsiteAbout',
                component: () => import('@/views/website/WebsiteAbout.vue')
            },
            {
                path: '/assetDetail/:registrationId',
                name: 'AssetDetail',
                component: () => import('../views/website/AssetDetail.vue'),
                meta: {
                    requireAuth: false
                }
            },
            {
                path: '/websiteFAQ',
                name: 'websiteFAQ',
                component: () => import('../views/website/WebsiteFAQ.vue'),
                meta: {
                    requireAuth: false
                }
            },
            {
                path: '/registration-guide',
                name: 'RegistrationGuide',
                component: () => import('../views/website/RegistrationGuide.vue'),
                meta: {
                    requireAuth: false
                }
            }
        ]
    },
    {
        path: '/index',
        name: Index,
        redirect: '/index/home',
        component: Index,
        children: [
            {
                path: '/index/home',
                name: '首页',
                component: () => import('../views/common/Home.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/index/boardDetails',
                name: '公告详情',
                component: BoardDetails,
            }, {
                path: '/index/authDetail',
                name: '企业认证',
                component: DetailAuthForm,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/index/auth',
                name: '企业认证',
                component: AuthForm,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/index/data-registration',
                name: '数据资产登记',
                component: DataRegistration,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/DataQuality',
                name: '数据质量评价',
                component: () => import('../views/company/DataQuality/DataQualityShowList'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/DataCompliance',
                name: '数据资产合规',
                component: () => import('../views/company/DataCompliance/DataComplianceShowList'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/data-compliance-apply',
                name: '数据合规评估申请',
                component: () => import('../views/company/DataCompliance/DataComplianceApply'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/data-compliance-detail',
                name: '数据合规评估详情',
                component: () => import('../views/company/DataCompliance/DataComplianceDetail'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/data-quality-apply',
                name: '数据质量评价申请',
                component: () => import('../views/company/DataQuality/DataQualityApply'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/data-quality-detail',
                name: '数据质量评价详情',
                component: () => import('../views/company/DataQuality/DataQualityDetail'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/index/data-review',
                name: '初审详情',
                component: () => import('../views/company/ReviewPage'),
                meta: {
                    requireAuth: true
                }
            },
            ,
            {
                path: '/index/data-review-re',
                name: '复审详情',
                component: () => import('../views/company/ReviewPageRe'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/index/data-review-ai',
                name: '智能合规评估',
                component: () => import('../views/manager/AIReview/ReviewPageAI'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/DataQualityManager',
                name: '质量评价列表',
                component: () => import('../views/manager/QualityEvaluation/DataQualityShowListManager'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/evaluationManager',
                name: '数据质量评价',
                component: () => import('../views/manager/QualityEvaluation/DataQualityEvaluation'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/evaluationDetailManager',
                name: '质量详情',
                component: () => import('../views/manager/QualityEvaluation/DataQualityDetailManager.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/index/review-page-view',
                name: '数据资产详情',
                component: () => import('../views/company/ReviewPageView'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/index/company/data-review',
                name: '企业数据审核',
                component: () => import('../views/company/DataReview'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/index/company/company-review',
                name: '企业数据认证审核',
                component: () => import('../views/company/CompanyReview'),
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/index/company/companyInfoView',
                name: '企业详情',
                component: () => import('../views/company/CompanyInfoView'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/index/company/detail',
                name: '企业详情',
                component: () => import('../views/company/CompanyDetail'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/index/company/review-manage',
                name: '审核管理',
                component: () => import('../views/company/ReviewPageManage'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/index/center',
                name: '个人中心',
                component: () => import('../views/common/Center'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/DataComplianceManager',
                name: '合规评估列表',
                component: () => import('../views/manager/DataCompliance/DataComplianceShowListManager'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/DataComplianceDetailManager',
                name: '评估详情',
                component: () => import('../views/manager/DataCompliance/DataComplianceDetailManager'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/ComplianceManager',
                name: '评估详情',
                component: () => import('../views/manager/DataCompliance/DataComplianceManager'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/ExcelAnalysis',
                name: 'Excel分析',
                component: () => import('../views/manager/Tools/ExcelAnalysisTool'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/DataValue',
                name: '数据价值管理', 
                component: () => import('../views/manager/DataValue/DataValue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/ValueAssessment',
                name: '数据价值评估',
                component: () => import('../views/manager/DataValue/ValueAssessment'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/DataValueApply',
                name: '数据价值申请',
                component: () => import('../views/manager/DataValue/DataValueApply'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/ValueAssessmentDetail',
                name: '价值评估详情',
                component: () => import('../views/manager/DataValue/ValueAssessmentDetail'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/PermissionConfig',
                name: '权限配置',
                component: () => import('../views/manager/Permission/PermissionConfig'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/PermissionMenu',
                name: '菜单配置',
                component: () => import('../views/manager/Permission/PermissionMenu'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/PermissionUser',
                name: '用户管理',
                component: () => import('../views/manager/Permission/PermissionUser'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Operation',
                name: '操作记录',
                component: () => import('../views/manager/Tools/OperationManage'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Consultation',
                name: '咨询管理',
                component: () => import('../views/manager/Tools/ConsultationManage'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Announcement',
                name: '公告管理',
                component: () => import('../views/manager/Tools/AnnouncementManage'),
                meta: {
                    requireAuth: true
                }
            }

        ],
        meta: {
            requireAuth: true
        }
    },
    // 添加 /home 重定向到 /index/home
    {
        path: '/home',
        redirect: '/index/home'
    },

];

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    //守卫
    //添加loading效果
    store.state.user = sessionStorage.getItem("user");

    const whiteList = ['/', '/login','/websiteFAQ', '/register', '/infoPublic', '/about', '/assetDetail', '/admin/login', '/registration', '/compliance', '/quality', '/valuation', '/finance'];
    const whiteListPatterns = [/^\/assetDetail\/\w+$/];

    console.log('to.path is ', to.path);
    if (whiteList.includes(to.path) || whiteListPatterns.some(pattern => pattern.test(to.path))) {
        next();
    } else {
        if (window.localStorage.getItem('user') || window.sessionStorage.getItem('user')) {
            initMenu(router, store);
            next();
        } else {
            if (to.path === '/login') {
                next();
            } else {
                next('/login');
            }
        }
    }
});

router.afterEach(router => {
    //添加一个loading加载完成的效果
});

export default router
